import { useSuspenseQuery } from '@tanstack/react-query'

import { GetVendedoresUnidadeNegocio } from '@/features/proposta/services/get-vendedores-unidade-negocio.service'
import { propostaKeys } from '@/features/proposta/utils'

export const useSuspenseVendedoresUnidadeNegocio = () => {
  return useSuspenseQuery({
    queryKey: propostaKeys.listaVendedores(),
    queryFn: async () => new GetVendedoresUnidadeNegocio().execute().then((res) => res.data),
  })
}
